module.exports = __webpack_public_path__ + "img/login-2.3c501481.jpg";